// 191B §A — ITEM 8: THE SUCCESS-FEE RATE IN FORCE, ONE DEFINITION FOR BOTH PLANES.
//
// ── THE COMPLAINT, AND WHAT THE MEASUREMENT SAID ────────────────────────────
//
// Laurent, 2026-09-17: a NEW pro forma draft on 2026/001 printed
// "Success fee : — %" in its particular conditions while the case's edit form
// showed 15. Measured in the DATABASE (the maint plane, never the form):
// 2026/001's stored `successFeeRate` is NULL — and so is every row on
// staging, 22 of 22 cases and 13 of 13 collective cases (`Float?`, no
// default, `server/prisma/schema.prisma`). Nothing was stored; the form was
// DISPLAYING a default it never wrote (`?? 15`), the money was COUNTING the
// same default (`caseFinancials.js`, `?? 15` at six sites), and the
// conditions text alone printed "—" — for a null AND for a stored 0
// (`cs.successFeeRate || "—"`).
//
// ── THE RULING (item 8, 2026-09-17) ──────────────────────────────────────────
//
// A null rate PRINTS THE SAME DEFAULT THE MONEY USES, from ONE definition,
// read by the form's display, the Success-fee panel and the pro forma prefill;
// a stored 0 prints 0, never "—"; a stored rate prints the rate.
//
// So the definition is a FUNCTION over the row, not a bare number: the number
// alone would leave "null → default" spelled per site, and `||` versus `??` at
// one of them is exactly how a stored 0 became "—". `successFeeRateOf(row)` is
// the rate in force — the stored value when there is one (0 included), else
// the default — and every reader asks it.
//
// ── WHY AN `.mjs` ─────────────────────────────────────────────────────────────
//
// The money is computed on the server (`server/src/lib/caseFinancials.js`,
// the function `recordings/c2-financials` replays bit-exact) and the three
// displays are in the browser; the server is CommonJS and cannot `require` a
// `.ts`. This tree's shape for a rule both planes read is one pure ESM module
// under `src/lib/`, imported by the client and `require`d by the server —
// `caseRefPattern.mjs`, `mentionTokens.mjs`, `themeVars.mjs`,
// `clientMatters.mjs` (which `caseFinancials.js` already requires).
//
// The money is UNCHANGED by construction: `(c.successFeeRate ?? 15)` became
// `successFeeRateOf(c)`, the same expression under a name, and the recordings
// (c2-financials · c2-costs · entryfees · ladder · rounds · reports) stay
// bit-exact — that is the extraction's proof.

/** The default a matter counts with when no rate is stored — percent. */
export const SUCCESS_FEE_RATE_DEFAULT = 15;

/**
 * The success-fee rate in force for a matter (or a matter FORM): the stored
 * value when there is one — a stored 0 is 0 — else the default. The `??` is
 * the whole rule: `||` would turn a stored 0 into the default.
 *
 * @param {{ successFeeRate?: number | null } | null | undefined} row  a case,
 *   a collective case, or the edit form of either
 * @returns {number}
 */
export function successFeeRateOf(row) {
  return (row && row.successFeeRate != null) ? row.successFeeRate : SUCCESS_FEE_RATE_DEFAULT;
}
